<template>
  <div class="contrast">
    <div class="item" v-for="(item, index) in contrastList" :key="item.FsNewsId">
      <div :class="['level', 'level' + (index + 1)]">
        <!-- <img src="https://img2.233.com/wx/union/pure/pc/class_bg_1.png" class="level" v-if="index === 0">
        <img src="https://img2.233.com/wx/union/pure/pc/class_bg_2.png" class="level" v-if="index === 1">
        <img src="https://img2.233.com/wx/union/pure/pc/class_bg_3.png" class="level" v-if="index === 2">
        <img src="https://img2.233.com/wx/union/pure/pc/class_bg_4.png" class="level" v-if="index === 3"> -->
        <span>{{item.BzCname}}</span>
      </div>
      <div class="box contrast-explain">
        <div class="title">适合人群</div>
        <div class="details">
          <ul class="circular" v-if="item.Explain">
            <!-- <li v-for="expl in item.Explain.split('↵').slice(1, item.Explain.split('↵').length)" :key="expl">
              <span>{{expl.slice(1, expl.length - 1)}}</span>
            </li> -->
            <li v-for="expl in item.Explain.split('\n')" :key="expl">
              <span>{{expl}}</span>
            </li>
          </ul>
          <ul class="circular" v-else>
            <li><span>无</span></li>
          </ul>
        </div>
      </div>
      <div class="box" v-if="item.Details">
        <div class="title">套餐价格</div>
        <div class="details contrast-price">
          <div class="price">
            <!-- <template v-if="fineAndDiy">
              <span>{{item.diyPrice}}</span>
            </template>
            <template v-else> -->
              <p v-for="(price, priceIdx) in item.Details" :key="priceIdx">
                <!-- <template  v-if="price.RowName === '单科'">
                  <template v-if="price.SpecialPrice">
                    <del>单科：{{price.Price}}</del>
                    <b>{{price.SpecialPrice}}</b>
                    <label>
                      <label>活动价:</label>
                      <strong>¥</strong>
                      <b>{{price.SpecialPrice}}</b>
                    </label>
                  </template>
                  <span v-else>单科：{{price.Price}}</span>
                  <div class="buy" @click="changeClassObj(price)">选课购买</div>
                </template>
                <template  v-else-if="price.RowName === '全科'">
                  <template v-if="price.SpecialPrice">
                    <del>全科：{{price.Price}}</del>
                    <b>{{price.SpecialPrice}}</b>
                    <label>
                      <label>活动价:</label>
                      <strong>¥</strong>
                      <b>{{price.SpecialPrice}}</b>
                    </label>
                  </template>
                  <span v-else>全科：{{price.Price}}</span>
                  <div class="buy" @click="changeClassObj(price)">选课购买</div>
                </template>
                <template v-else>
                  <template v-if="price.SpecialPrice">
                    <del>{{price.Price}}</del>
                    <b>{{price.SpecialPrice}}</b>
                    <label>
                      <label>活动价:</label>
                      <strong>¥</strong>
                      <b>{{price.SpecialPrice}}</b>
                    </label>
                  </template>
                  <span v-else>{{price.Price}}</span>
                  <div class="buy" @click="changeClassObj(price)">选课购买</div>
                </template> -->
                <template>
                  <div class="left">
                    <template v-if="price.SpecialPrice">
                      <span :title="price.RowName">{{price.RowName}}:</span>
                      <del>{{price.Price}}<b>{{price.SpecialPrice}}</b></del>
                    </template>
                    <template v-else>
                    <span :title="price.RowName">{{price.RowName}}:</span>
                    <label>{{price.Price}}</label>
                    </template>
                  </div>
                  <div class="buy" @click="changeClassObj(price)">购买</div>
                </template>
              </p>
            <!-- </template> -->
          </div>
        </div>
        <!-- <div class="buy" @click="changeClassObj(item)">选课购买</div> -->
      </div>
      <div class="box contrast-course" v-if="!fineAndDiy">
        <div class="title">包含课程</div>
        <div class="details">
          <ul :class="['course', 'course' + (index + 1)]">
            <li v-if="item.GettingStarted && item.GettingStarted.length > 0">
              <label>入门</label>
              <div class="labels">
                <span v-for="gs in item.GettingStarted" :key="gs">{{gs}}</span>
              </div>
            </li>
            <li v-if="item.Basis && item.Basis.length > 0">
              <label>基础</label>
              <div class="labels">
                <span v-for="bas in item.Basis" :key="bas">{{bas}}</span>
              </div>
            </li>
            <li v-if="item.Strengthen && item.Strengthen.length > 0">
              <label>强化</label>
              <div class="labels">
                <span v-for="st in item.Strengthen" :key="st">{{st}}</span>
              </div>
            </li>
            <li v-if="item.Sprint && item.Sprint.length > 0">
              <label>冲刺</label>
              <div class="labels">
                <span v-for="spr in item.Sprint" :key="spr">{{spr}}</span>
              </div>
            </li>
          </ul>
          <ul class="circular" v-if="(!item.GettingStarted || item.GettingStarted.length === 0) && (!item.Basis || item.Basis.length === 0) && (!item.Strengthen || item.Strengthen.length === 0) && (!item.Sprint || item.Sprint.length === 0)">
            <li><span>无</span></li>
          </ul>
        </div>
      </div>
      <div class="box" v-if="!fineAndDiy">
        <div class="title">服务保障</div>
        <div class="details contrast-fwbz">
          <ul class="circular">
            <li>
              <span>{{item.ExpirationDate || "无"}}</span>
            </li>
            <li v-if="ShowRelearn === 0">
              <span v-if="item.Relearning === 0">无重学服务</span>
              <span v-else-if="item.Relearning <= 9">考试不过，可根据成绩单，<b>免费重学{{item.Relearning}}次</b></span>
              <span v-else>考试不过，可根据成绩单，<b>重学至通关</b></span>
            </li>
          </ul>
        </div>
        <div class="title">
          赠送资料
          <a @click="changeGift(item.Details)" v-if="item.JiaoCai || item.JiaoFu || item.TiKu">查看赠品详情</a>
        </div>
        <div class="details contrast-zszl">
          <ul class="material" v-if="item.JiaoCai || item.JiaoFu || item.TiKu">
            <li v-if="item.JiaoCai">
              <span>官方正版教材【包邮】<label class="not-send" v-if="item.JiaoCaiPartNoGive">部分班级不送</label></span>
            </li>
            <li v-if="item.JiaoFu">
              <span>老师精编教辅【包邮】<label class="not-send" v-if="item.JiaoFuPartNoGive">部分班级不送</label></span>
            </li>
            <li v-if="item.TiKu">
              <span>题库会员</span>
            </li>
          </ul>
          <ul class="circular" v-else>
            <li><span>无</span></li>
          </ul>
        </div>
        <div class="title">套餐服务</div>
        <div class="details contrast-tcfw">
          <ul class="service" v-if="item.ZiLiao || item.DayiFlag">
            <li v-if="item.ZiLiao">
              <span>考前资料</span>
            </li>
            <li>
              <span v-if="item.DayiFlag">助教答疑服务</span>
            </li>
          </ul>
          <ul class="circular" v-else>
            <li><span>无</span></li>
          </ul>
        </div>
      </div>
      <div class="box contrast-bhbj" v-if="fineAndDiy">
        <div class="title">包含班级</div>
        <div class="details">
          <ul class="circular" v-if="item.BHBJ.length > 0">
            <li v-for="(bhbji, idxi) in item.BHBJ" :key="idxi">
              <span>{{bhbji.Contents}}</span>
            </li>
          </ul>
          <ul class="circular" v-else>
            <li><span>无</span></li>
          </ul>
        </div>
      </div>
      <div class="box contrast-kcbz" v-if="fineAndDiy">
        <div class="title">课程保障</div>
        <div class="details">
          <ul class="circular" v-if="item.KCBZ.length > 0">
            <li v-for="(kcbzi, idxi) in item.KCBZ" :key="idxi">
              <span v-if="kcbzi.StyleId !== 1">{{kcbzi.Contents}}</span>
              <b v-else>{{kcbzi.Contents}}</b>
            </li>
          </ul>
          <ul class="circular" v-else>
            <li><span>无</span></li>
          </ul>
        </div>
      </div>
      <div class="box contrast-tsbj" v-if="fineAndDiy">
        <div class="title">特色班级</div>
        <div class="details">
          <ul class="circular" v-if="item.TSBJ.length > 0">
            <li v-for="(tsbji, idxi) in item.TSBJ" :key="idxi">
              <span v-if="tsbji.StyleId !== 1">{{tsbji.Contents}}</span>
              <b v-else>{{tsbji.Contents}}</b>
            </li>
          </ul>
          <ul class="circular" v-else>
            <li><span>无</span></li>
          </ul>
        </div>
      </div>
      <div class="box contrast-kcts" v-if="fineAndDiy">
        <div class="title">课程特色</div>
        <div class="details">
          <ul class="circular" v-if="item.KCTS.length > 0">
            <li v-for="(kctsi, idxi) in item.KCTS" :key="idxi">
              <span v-if="kctsi.StyleId !== 1">{{kctsi.Contents}}</span>
              <b v-else>{{kctsi.Contents}}</b>
            </li>
          </ul>
          <ul class="circular" v-else>
            <li><span>无</span></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contrast",
  props: {
    ShowRelearn: {
      type: Number,
      default: 0
    },
    fineAndDiy: {
      type: Boolean,
      default: false
    },
    contrastList: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    this.autoHeight("explain")
    this.autoHeight("course")
    this.autoHeight("fwbz")
    this.autoHeight("zszl")
    this.autoHeight("tcfw")
    this.autoHeight("bhbj")
    this.autoHeight("kcbz")
    this.autoHeight("tsbj")
    this.autoHeight("kcts")
    this.autoHeight("price")
  },
  methods: {
    // changeClassObj(item) {
    //   const { Details, BzCname } = item
    //   let _arr = []
    //   if (Details && Details.length > 0) {
    //     Details.forEach(element => {
    //       _arr = [..._arr, ...element.Details]
    //     })
    //     if (_arr.length === 1) {
    //       window.open('/shopping/?myclassid=' + _arr[0].MyClassId)
    //       return
    //     }
    //     this.$emit('changeClassObj', { BzContainMyClassList: _arr, BzCName: BzCname })
    //   }
    // },
    changeClassObj(item) {
      const { Details, RowName } = item
      let _arr = []
      if (Details && Details.length > 0) {
        Details.forEach(element => {
          _arr = [..._arr, element]
        })
        if (_arr.length === 1) {
          window.open('/shopping/?myclassid=' + _arr[0].MyClassId)
          return
        }
        this.$emit('changeClassObj', { BzContainMyClassList: _arr, BzCName: RowName })
      }
    },
    changeGift(list) {
      let _arr = []
      list.forEach(element => {
        _arr = [..._arr, ...element.Details]
      })
      _arr.map(item => item.ZengpinFlag)
      this.$emit('changeGift', _arr)
    },
    autoHeight(type) {
      let _height = 0
      document.querySelectorAll(".contrast-" + type).forEach(item => {
        _height = item.offsetHeight > _height ? item.offsetHeight : _height
      })
      document.querySelectorAll(".contrast-" + type).forEach(item => {
        item.style.height = _height + "px"
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../assets/css/index.scss";
.contrast{
  display: flex;
  justify-content: space-between;
  .item{
    width: 285px;
    margin-right: 20px;
    flex: 1;
    &:nth-last-child(1){
      margin-right: 0;
    }
    .level{
      width: 100%;
      position: relative;
      overflow: hidden;
      height: 115px;
      // img{
      //   vertical-align: top;
      //   width: 100%;
      //   height: 115px;
      //   width: 590px;
      // }
      span{
        position: absolute;
        top: 36px;
        left: 118px;
        color: #fff;
        font-size: 28px;
        font-weight: 300;
        // top: calc(50% - 20px);
        // width: 60%;
        // left: 42%;
        // text-align: left;
      }
    }
    .level1{
      background: url(https://img2.233.com/wx/union/pure/pc/class_bg_1.png) no-repeat;
    }
    .level2{
      background: url(https://img2.233.com/wx/union/pure/pc/class_bg_2.png) no-repeat;
    }
    .level3{
      background: url(https://img2.233.com/wx/union/pure/pc/class_bg_3.png) no-repeat;
    }
    .level4{
      background: url(https://img2.233.com/wx/union/pure/pc/class_bg_4.png) no-repeat;
    }
    .box{
      margin-top: 9px;
      background: #F9F9F9;
      box-shadow: 1px 15px 18px 1px rgba(0, 0, 0, 0.02);
      .title{
        background: #F9F9F9;
        background: linear-gradient(90deg, #E7E7E7, #F9F9F9);
        line-height: 34px;
        width: 189px;
        padding-left: 13px;
        border-left: 2px solid #B4776B;
        margin-left: -2px;
        color: #343434;
        font-size: 16px;
        font-weight: bold;
        position: relative;
        width: 75%;
        a{
          font-size: 13px;
          color: #DF3030;
          font-weight: 400;
          position: absolute;
          top: 0;
          cursor: pointer;
          right: -22%;
        }
      }
      .details{
        padding: 13px 0 0 14px;
        ul{
          padding-bottom: 18px;
          li{
            list-style: none;
            b{
              color: #DF3030;
              font-size: 14px;
              word-break: break-all;
            }
            span{
              color: #565656;
              font-size: 14px;
              font-weight: 400;
              line-height: 28px;
              word-break: break-all;
            }
          }
        }
        .circular{
          li{
            &::before{
              content: "";
              display: inline-block;
              width: 7px;
              height: 7px;
              border: 1px solid #414141;
              border-radius: 50%;
              margin-right: 8px;
            }
          }
        }
        .material{
          li{
            &::before{
              content: "送";
              display: inline-block;
              width: 17px;
              height: 17px;
              line-height: 17px;
              border: 1px solid #E61313;
              color: #E61313;
              font-size: 13px;
              font-weight: 400;
              text-align: center;
              margin-right: 8px;
            }
            .not-send{
              color: #E61313;
              font-size: 12px;
            }
          }
        }
        .service{
          li{
            &::before{
              content: "享";
              display: inline-block;
              width: 17px;
              height: 17px;
              line-height: 17px;
              border: 1px solid #4D8C85;
              color: #4D8C85;
              font-size: 13px;
              font-weight: 400;
              text-align: center;
              margin-right: 8px;
            }
          }
        }
        .course{
          // width: 259px;
          width: 95%;
          li{
            position: relative;
            padding: 7px 0 7px 65px;
            box-sizing: border-box;
            background: #F4F4F4;
            margin-top: 11px;
            label{
              position: absolute;
              top: 0;
              left: 0;
              width: 39px;
              height: 21px;
              line-height: 21px;
              color: white;
              font-size: 14px;
              font-weight: 400;
              background: #B4766C;
              text-align: center;
            }
            span{
              margin-right: 24px;
              display: inline-block;
            }
          }
        }
        .course2 li label{
          background: #AA947B;
        }
        .course3 li label{
          background: #859AAD;
        }
        .course4 li label{
          background: #7C8788;
        }
        .price{
          min-height: 90px;
          // padding-top: 10px;
          p{
            margin-top: 12px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-right: 13px;
            &:nth-child(1){
              margin-top: 0;
            }
            .left{
              display: flex;
              align-items: center;
            }
            span{
              // display: block;
              color: #565656;
              font-size: 14px;
              font-weight: 400;
              line-height: 28px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              display: inline-block;
              max-width: 100px;
            }
            del{
              color: #888;
              font-size: 14px;
              font-weight: 400;
              // margin-right: 26px;
              position: relative;
              min-width: 123px;
            }
            label{
              color: #E50C0C;
              font-size: 15px;
              font-weight: 400;
              display: inline-block;
            }
            strong{
              color: #E50C0C;
              font-size: 18px;
              font-weight: 400;
              margin: 0 4px;
            }
            // b{
            //   color: #E50C0C;
            //   font-size: 22px;
            //   font-weight: 400;
            // }
            b{
              position: absolute;
              top: -20px;
              left:0px;
              color: #E50C0C;
              font-size: 15px;
              font-weight: 400;
              background: #fbc9c9;
              padding: 0 6px;
              &::before{
                content: "";
                position: absolute;
                bottom: -4px;
                left: 4px;
                width: 0;
                height: 0;
                border-top: 4px solid #fbc9c9;
                border-right: 4px solid transparent;
                border-left: 4px solid transparent;
              }
            }
          }
        }
      }
      // .buy{
      //   display: inline-block;
      //   width: 284px;
      //   height: 49px;
      //   @include meal_contrast_buy();
      //   line-height: 49px;
      //   color: white;
      //   font-weight: 400;
      //   font-size: 18px;
      //   text-align: center;
      //   cursor: pointer;
      //   width: calc(100% - 13px);
      //   &:hover{
      //     @include meal_contrast_buy_hover();
      //   }
      // }
      .buy{
        display: inline-block;
        @include meal_contrast_buy();
        color: white;
        font-weight: 400;
        height: 28px;
        line-height: 28px;
        font-size: 14px;
        border-radius: 4px;
        min-width: 48px;
        text-align: center;
        cursor: pointer;
        &:hover{
          @include meal_contrast_buy_hover();
        }
      }
    }
  }
}
</style>